import { render, staticRenderFns } from "./PdfReportSuperAdmin.vue?vue&type=template&id=2d98bc6a&"
import script from "./PdfReportSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./PdfReportSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports